import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import {
  ValidationRules,
  ValidationControllerFactory,
  ValidationController,
  ControllerValidateResult,
} from "aurelia-validation";
import { AuthService } from "../../services/auth/auth-service";
import { BootstrapFormRenderer } from "../../validation/bootstrap-form-renderer";

@autoinject
export class Login {
  username: string;
  password: string;
  loginError: boolean;

  private validationController: ValidationController;

  constructor(
    private i18n: I18N,
    private validationControllerFactory: ValidationControllerFactory,
    private authService: AuthService,
  ) {
    this.validationController =
      this.validationControllerFactory.createForCurrentScope();
    this.validationController.addRenderer(new BootstrapFormRenderer());

    ValidationRules.ensure((d: Login) => d.username)
      .displayName(i18n.tr("auth.username") as string)
      .required()
      .withMessageKey("auth.usernameRequired")
      .maxLength(200)
      .ensure((d: Login) => d.password)
      .displayName(this.i18n.tr("auth.password") as string)
      .required()
      .withMessageKey("auth.passwordRequired")
      .maxLength(200)
      .on(this);
  }

  login() {
    this.loginError = false;
    this.validationController
      .validate()
      .then((result: ControllerValidateResult) => {
        if (!result.valid) return;
        return this.authService
          .login({
            username: this.username,
            passwordHash: this.authService.hash(this.password),
          })
          .then((_) => {
            this.loginError = false;
          })
          .catch((err) => {
            console.log("login failure", err);
            this.loginError = true;
          });
      });
  }
}
